var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { observer } from "mobx-react";
import MProductsStore from "./store";
import { ProductSkeletonContainer } from "./styles.index";
import { fetchCardBoxByGrid } from "./styles.card";
import ScrollLoad from "../../components/ScrollLoad";
import { isNotBlankArray } from "../../../utils/array";
import { ModuleLayoutStyle } from "../../../services/playground";
import ViewMoreCard from "../../components/ViewMoreCard";
import NormalProductCard from "./ProductCard";
import TomatoProductCard from "./NewProductCard";
import NormalProductCardTag from "./TagGroup";
import SlideProductGroup from "./SlideTemplate";
import SmallLoading from "../../components/SmallLoading";
import { isInWindowView } from "../../../utils/browser";
let NormalProductGroup = class NormalProductGroup extends React.Component {
    constructor(props) {
        var _a, _b, _c;
        super(props);
        this.scrollTop = 0;
        this.preProductIndex = 0;
        this.state = {
            activeTab: this.props.activeTab || ((_b = (_a = this.props.productModules) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.poolId) || "",
            isChangeTab: false,
            showedProducts: [],
        };
        this.newCardRef = React.createRef();
        this.onScroll = () => {
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = setTimeout(this.isScrollEnd, 600);
            this.scrollTop = window.scrollY || window.pageYOffset;
        };
        this.isScrollEnd = () => {
            var _a;
            const endTop = window.scrollY || window.pageYOffset;
            const currentElement = (_a = this.newCardRef) === null || _a === void 0 ? void 0 : _a.current;
            if (endTop === this.scrollTop && isInWindowView(currentElement)) {
                this.trackOnShow();
            }
        };
        this.trackOnShow = () => {
            const { SetCtrTrackOnShow, SetGtmTrackOnShow } = this.props;
            const { showedProducts } = this.state;
            if (showedProducts.length > 0 && (SetCtrTrackOnShow || SetGtmTrackOnShow)) {
                let posArr = [];
                let pidsArr = [];
                showedProducts.forEach((item, i) => {
                    posArr.push(i + 1 + this.preProductIndex);
                    pidsArr.push(item.gpid);
                });
                SetCtrTrackOnShow && SetCtrTrackOnShow(posArr.join(","), pidsArr);
                SetGtmTrackOnShow && SetGtmTrackOnShow(showedProducts, posArr);
                this.preProductIndex = this.preProductIndex + showedProducts.length;
                this.setState({ showedProducts: [] });
            }
        };
        this.onLoadMoreProducts = () => __awaiter(this, void 0, void 0, function* () {
            const poolId = this.state.activeTab;
            const { loadProductsList, isLoadEnd, productsListMap } = this.MNormalProductStore;
            const newProducts = (yield loadProductsList(poolId, this.props.onLoadPool)) || [];
            const products = productsListMap[poolId];
            this.setState({
                showedProducts: [...this.state.showedProducts, ...newProducts],
            });
            return { loadCount: products === null || products === void 0 ? void 0 : products.length, isError: false, isDisable: isLoadEnd[poolId] };
        });
        this.onChangeTab = (poolId, index) => {
            if (this.props.onClickTab) {
                this.props.onClickTab(index);
            }
            this.setState({
                activeTab: poolId,
            });
            if (isNotBlankArray(this.MNormalProductStore.productsListMap[poolId])) {
                return;
            }
            this.preProductIndex = 0;
            this.setState({
                isChangeTab: true,
                showedProducts: [],
            }, () => __awaiter(this, void 0, void 0, function* () {
                const { loadProductsList } = this.MNormalProductStore;
                const newProducts = (yield loadProductsList(poolId, this.props.onLoadPool)) || [];
                this.setState({
                    showedProducts: [...this.state.showedProducts, ...newProducts],
                    isChangeTab: false,
                });
                this.trackOnShow();
            }));
        };
        this.onClickProduct = (pos, pid) => {
            this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(pos, pid);
        };
        this.renderMProductsList = () => {
            const { isRollable, layout, placeholderBg, isInApp, viewMore = "View More", notUseQnparams = false, } = this.props;
            const products = this.MNormalProductStore.productsListMap[this.state.activeTab];
            const viewMoreLink = this.MNormalProductStore.viewMoreLink[this.state.activeTab];
            if (!products) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                (products || []).map((pool, index) => {
                    const cardProps = {
                        columnNum: layout.columnNum || 2,
                        key: pool.gpid,
                        productElement: pool,
                        index,
                        isRollable: !!isRollable,
                    };
                    if (this.props.layoutStyle === ModuleLayoutStyle.Tomato) {
                        return (React.createElement(TomatoProductCard, Object.assign({ placeholderBg: placeholderBg, posterRadio: this.props.posterRadio }, cardProps)));
                    }
                    return (React.createElement(NormalProductCard, Object.assign({}, cardProps, { key: pool.gpid, isInApp: !!isInApp, onClick: () => this.onClickProduct((index + 1).toString(), pool.gpid), isWithViewMore: !!viewMoreLink, stylesForCard: this.props.stylesForCard, placeholderBg: placeholderBg, notUseQnparams: notUseQnparams, layoutStyle: this.props.layoutStyle || ModuleLayoutStyle.Orange })));
                }),
                !!viewMoreLink && (React.createElement(ViewMoreCard, { StyledComponent: fetchCardBoxByGrid(+(layout.columnNum || 2)), isRollable: isRollable, key: `${viewMoreLink}_VIEWMORE`, link: viewMoreLink, text: viewMore, isInApp: !!isInApp }))));
        };
        this.MNormalProductStore = new MProductsStore(props.productModules);
        const activeTab = props.activeTab || ((_c = props.productModules[0]) === null || _c === void 0 ? void 0 : _c.poolId);
        this.state = {
            activeTab,
            isChangeTab: false,
            showedProducts: this.MNormalProductStore.productsListMap[activeTab] || [],
        };
    }
    componentDidMount() {
        const { loadProductsList, productsListMap } = this.MNormalProductStore;
        const currentPool = productsListMap[this.state.activeTab];
        if (!isNotBlankArray(currentPool) && this.props.isRollable) {
            loadProductsList(this.state.activeTab, this.props.onLoadPool);
        }
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    render() {
        const { positionId, stickToTop = 0, canScrollFixed, isRollable, layout } = this.props;
        const poolId = this.state.activeTab;
        const products = this.MNormalProductStore.productsListMap[this.state.activeTab];
        let loading = poolId ? this.MNormalProductStore.isLoadingProducts[poolId] : false;
        const { gap = 0.5, columnNum = 2, parentGap = 0.5 } = layout;
        loading = loading || this.state.isChangeTab;
        return (React.createElement("section", { id: positionId, ref: this.newCardRef },
            isNotBlankArray(this.props.tagGroup) && (React.createElement(NormalProductCardTag, { activeTab: this.props.activeTab || "", canScrollFixed: !!canScrollFixed, clientElement: this.newCardRef, stickToTop: stickToTop, tagGroup: this.props.tagGroup || [], onClick: this.onChangeTab })),
            isRollable ? (React.createElement(SlideProductGroup, { gridGap: gap, parentGap: parentGap, isLoading: loading && !isNotBlankArray(products), onLoadMoreContent: () => {
                    this.MNormalProductStore.loadProductsList(poolId, this.props.onLoadPool);
                } }, this.renderMProductsList())) : (React.createElement(ScrollLoad, { StyleComponent: ProductSkeletonContainer, grid: { gridCol: columnNum, gridGap: gap, parentGap }, isDisable: this.MNormalProductStore.isLoadEnd[poolId], loadFunction: this.onLoadMoreProducts, loadDataWhenDidMount: false },
                this.renderMProductsList(),
                loading && React.createElement(SmallLoading, null)))));
    }
};
NormalProductGroup = __decorate([
    observer
], NormalProductGroup);
export default NormalProductGroup;
